import AddActivity from "./AddActivity";
import AddVirtualBusiness from "./AddVirtualBusiness";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import CompanySteps from "./CompanySteps";
import AddObjective from "./AddObjective";
import VerifyBusiness from "./VerifyBusiness";
import GetToaster from "../../../components/header/getToaster";
import { selectedCompanyStepAction, selectPendingCompany, setBusinessDataAction } from "../../../actions/company";
import { PREDEFINED_ADDRESS } from "../../../constants";
import { RoutesPaths } from "../../../Router/constant";
import AddEmail from "./AddEmail";

export default function AddBusinessModal() {
  const {
    register,
    handleSubmit,
    getValues,
    setValue,
    reset,
    watch,
    formState: { errors },
  } = useForm();
  const navigate = useNavigate()
  const { selectedCompanyStep } = useSelector((state) => state.company);
  const { toastMessage } = useSelector(state => state.message)

  const dispatch = useDispatch();

  watch(["logo"]);

  const updateForm = async (data, type) => {
    if ("logo" in data && data?.logo?.length === 0) {
      data.logo = "";
    }
    let payload = {
      companyName: data?.companyName,
      companyWebsite: data?.companyWebsite,
      city: PREDEFINED_ADDRESS.CITY,
      country: PREDEFINED_ADDRESS.COUNTRY,
      postalCode: PREDEFINED_ADDRESS.POSTAL_CODE,
      primaryAddress: PREDEFINED_ADDRESS.LINE1,
      logo: data.logo,
      isTick: data.isTick ? data.isTick : false,
      about: data.about
    };
    localStorage.removeItem("token");

    if (data?.companyName?.trimLeft().length > 0) {
      return payload;
    }
  };

  const onSubmit = async (data) => {
    if (data?.companyName?.trimLeft().length > 0) {
      const successCompanyResp = await updateForm(data, true);
      dispatch(setBusinessDataAction(successCompanyResp));
      dispatch(selectedCompanyStepAction(2))
      reset();
    }
  };

  const handleClose = async () => {
    let data = {
      companyName: getValues("companyName") || null,
      companyWebsite: getValues("companyWebsite") || null,
      logo: getValues("logo") || null,
      isTick: getValues("isTick") || null,
      about: getValues("about") || null,
    };
    await updateForm(data, false);
    navigate(RoutesPaths.LANDING_PUBLIC, { replace: true })
    dispatch(selectedCompanyStepAction(1))
    dispatch(selectPendingCompany(null));
    reset();
  };

  return (
    <div className="buyProductSectionBgScroll">
      <div className="container-fluid">
        {toastMessage && <GetToaster />}
        <CompanySteps selectedStep={selectedCompanyStep} />
      </div>
      <div className="container bankPage">
        <div className="row buyProductSection">
          <div className="col-md-8">
            <div className="container">
              <div className="row buyProductSectionBg">
                <div className="col-md-12">
                  <div className="userDetail">

                    {selectedCompanyStep === 1 ?
                      <AddVirtualBusiness register={register} handleSubmit={handleSubmit} getValues={getValues} onSubmit={onSubmit} setValue={setValue} errors={errors} handleClose={handleClose} />
                      : selectedCompanyStep === 2 ? <AddActivity />
                        : selectedCompanyStep === 3 ? <AddObjective />
                          : selectedCompanyStep === 4 ? <VerifyBusiness /> : <AddEmail />
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>
  );
}
